import gql from 'graphql-tag';

export const GET_SST_DATA = gql`
query($id: String!) {
  sst(id: $id) {
    solar_controller_data {
      monitoring_error
      deep_discharge_protection_warn_triggered
      deep_discharge_protection_triggered
      over_voltage_protection_triggered
      charge_current
      array_current
      battery_terminal_voltage
      array_voltage
      load_voltage
      battery_current
      load_current
      battery_sense_voltage
      battery_voltage_slow_filter
      battery_current_slow_filter
      timestamp
    }
    mobile_router_data {
      monitoring_error
      mobile_provider
      signal_strength
      cell_identity
      location_area_code
      location_area_id
      mobile_service_type
      registration_state
      timestamp
    }
    fuse_3 {
      released
      timestamp 
    }
    fuse_4 {
      released
      timestamp 
    }
    fuse_6 {
      released
      timestamp
    }
    door_contact {
      open
      timestamp
    }
    gps_data {
      longitude
      latitude
      timestamp
    }
    temperature_data_cabinet {
      temperature
      timestamp
    }
    temperature_data_board {
      temperature
      timestamp
    }
  }
}
`;

export const RESET_SST = gql`
  mutation resetSST($id: String!, $cause: String!, $initiator: String!) {
    resetSST(id: $id, cause: $cause, initiator: $initiator)
  }
`;

export const TURN_ON = gql`
  mutation turnOn($id: String!, $cause: String!, $initiator: String!) {
    turnOn(id: $id, cause: $cause, initiator: $initiator)
  }
`;

export const TURN_OFF = gql`
  mutation turnOff($id: String!, $cause: String!, $initiator: String!) {
    turnOff(id: $id, cause: $cause, initiator: $initiator)
  }
`;


export const GET_HISTORIC_SOLARCONTROLLER_DATA = gql`
  query historicSolarControllerData($id: String!) {
    historicSolarControllerData(id: $id)
    {
      battery_voltage
      charging_capacity
      solar_energy
      energy_consumption
      timestamp
    }
  }
`;